<div class="qr-scanner-container relative">
  <!-- Loading overlay -->
  <div *ngIf="isLoading" class="absolute inset-0 bg-black bg-opacity-50 row-center-center z-40 rounded-lg">
    <div class="text-white text-center">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto mb-2"></div>
      <p>{{ 'QRScanner_InitializingCamera' | translateWF: 'Initializing camera...' }}</p>
    </div>
  </div>

  <!-- Camera not available message -->
  <div *ngIf="!hasCamera && !isScanning" class="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-4">
    <p class="text-sm">
      <i class="pi pi-exclamation-triangle mr-2"></i>
      {{ 'QRScanner_NoCameraDetected' | translateWF: 'No camera detected on this device. You can still scan by uploading an image below.' }}
    </p>
  </div>

  <!-- Video element for camera -->
  <div class="video-wrapper relative rounded-lg overflow-hidden opacity-0" [class.active]="isScanning && !isLoading">
    <video #videoElement class="w-full max-w-md mx-auto block" [attr.autoplay]="true" [attr.muted]="true" [attr.playsinline]="true"></video>

    <!-- Framing guide overlay -->
    <div *ngIf="showFramingGuide && isScanning" class="absolute inset-0 row-center-center pointer-events-none">
      <div class="border-2 border-green-400 bg-transparent w-48 h-48 rounded-lg">
        <div class="relative w-full h-full">
          <!-- Corner guides -->
          <div class="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4 border-green-400"></div>
          <div class="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4 border-green-400"></div>
          <div class="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4 border-green-400"></div>
          <div class="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4 border-green-400"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Control buttons -->
  <div class="col mt-4">
    <!-- Scanning Mode Toggle -->
    <div class="flex flex-wrap gap-2 justify-center mb-2">
      <span class="text-sm text-gray-600 mr-2 row-start-center">{{ 'QRScanner_ScanMode' | translateWF: 'Scan Mode:' }}</span>
      <button
        (click)="setScanningMode('qr')"
        [class]="scanningMode === 'qr' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        class="px-3 py-1 rounded-md text-sm transition-colors"
      >
        {{ 'QRScanner_QRCodes' | translateWF: 'QR Codes' }}
      </button>
      <button
        (click)="setScanningMode('barcode')"
        [class]="scanningMode === 'barcode' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        class="px-3 py-1 rounded-md text-sm transition-colors"
      >
        {{ 'QRScanner_Barcodes' | translateWF: 'Barcodes' }}
      </button>
      <button
        (click)="setScanningMode('both')"
        [class]="scanningMode === 'both' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'"
        class="px-3 py-1 rounded-md text-sm transition-colors"
      >
        {{ 'QRScanner_Both' | translateWF: 'Both' }}
      </button>
    </div>

    <!-- Start/Stop scanning buttons -->
    <div class="row-sm justify-center">
      <button
        *ngIf="!isScanning && hasCamera"
        (click)="startScanning()"
        [disabled]="isLoading"
        class="bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg row-sm-start-center transition-colors"
      >
        <i class="pi pi-camera"></i>
        <span>{{ 'QRScanner_StartScanning' | translateWF: 'Start Scanning' }}</span>
      </button>

      <button *ngIf="isScanning" (click)="stopScanning()" class="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg row-sm-start-center transition-colors">
        <i class="pi pi-times"></i>
        <span>{{ 'QRScanner_StopScanning' | translateWF: 'Stop Scanning' }}</span>
      </button>
    </div>

    <!-- File upload section -->
    <div *ngIf="showFileUpload" class="border-t pt-3">
      <p class="text-sm text-gray-600 mb-2 text-center">{{ 'QRScanner_OrScanFromImage' | translateWF: 'Or scan from an image:' }}</p>

      <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" class="hidden" />

      <button
        (click)="triggerFileUpload()"
        [disabled]="isLoading"
        class="w-full bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50 text-gray-700 px-4 py-2 rounded-lg border border-gray-300 row-center-center gap-2 transition-colors"
      >
        <i class="pi pi-upload"></i>
        <span>{{ 'QRScanner_UploadImage' | translateWF: 'Upload Image' }}</span>
      </button>
    </div>
  </div>

  <!-- Status messages -->
  <div class="mt-3">
    <p *ngIf="isScanning && !isLoading" class="text-sm text-green-600 text-center">
      <i class="pi pi-check-circle mr-1"></i>
      {{ 'QRScanner_PointCamera' | translateWF: 'Point your camera at a QR code or barcode' }}
    </p>

    <p *ngIf="lastScannedCode" class="text-xs text-gray-500 text-center mt-2">{{ 'QRScanner_LastScanned' | translateWF: 'Last scanned:' }} {{ lastScannedCode }}</p>
  </div>
</div>
